import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    const verify = async () => {
      const { data, error: authError } = await supabase.auth.getUser();
      if (!active) return;
      if (data.user) {
        navigate("/governance", { replace: true });
      } else if (authError) {
        setError("We couldn't confirm your sign-in. Please try again.");
      }
    };
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) window.setTimeout(() => { void verify(); }, 0);
    });
    void verify();
    const timeout = window.setTimeout(() => {
      if (active) setError("Sign-in did not complete. Please try again.");
    }, 15000);
    return () => { active = false; data.subscription.unsubscribe(); window.clearTimeout(timeout); };
  }, [navigate]);

  return (
    <main className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4" role="status">
        <h1 className="font-sans text-2xl font-semibold">{error ? "Sign-in incomplete" : "Confirming your account…"}</h1>
        {error && <><p className="text-muted-foreground">{error}</p><Button asChild><Link to="/governance">Return to sign in</Link></Button></>}
      </div>
    </main>
  );
}